import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { License } from '@portal-core/licenses/models/license.model';

@CollectionStateSelectors({
  stateType: LicensesState
})
@State<LicensesState>({
  name: LicensesState.source
})
@Service({ autoProvided: false })
export class LicensesState extends CollectionStateBase {
  static override source = 'Licenses';
  getSource(): string {
    return LicensesState.source;
  }
}

@Service()
export class LicensesDataService extends CollectionDataServiceBase<License> {
  protected readonly stateType = LicensesState;
}
